import
{ layout } from 'src/styles/layout';
import styled, { css } from 'styled-components';

interface DynamicSectionContainerProps {
  background?: string;
  isColumn?: boolean;
  horizontalPadding?: number;
  verticalPadding?: number;
  maxWidth?: string;
  marginTop?: string;
}

export const DynamicSectionContainer = styled.section<DynamicSectionContainerProps>`
  max-width: ${({ maxWidth }) => maxWidth ?? '100vw' } !important;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;

  ${({ isColumn }) => !isColumn ? '' : css`
    padding: 48px;
    height: 100%;
  `}

  ${({ marginTop }) => !marginTop ? '' : css`
    margin-top: ${ marginTop };
  ` }

  ${({ background }) => !background ? '' : css`
    background: ${ background };
  ` }

  ${({ horizontalPadding }) => typeof horizontalPadding === 'number' ? css`
    padding-right: ${ horizontalPadding }px;
    padding-left: ${ horizontalPadding }px;
  ` : ''}

  ${({ verticalPadding }) => typeof verticalPadding === 'number' ? css`
    padding-top: ${ verticalPadding }px;
    padding-bottom: ${ verticalPadding }px;
  ` : ''}
`;

interface DynamicSectionColumnContainerProps {
  firstGridColumnSize: number;
  secondGridColumnSize: number;
  maxWidth?: string;
  breakpoint?: string;
}

export const DynamicSectionColumnContainer = styled.div<DynamicSectionColumnContainerProps>`
  max-width: ${({ maxWidth }) => maxWidth ?? '100vw'} !important;
  display: grid;
  grid-template-columns: ${({ firstGridColumnSize, secondGridColumnSize }) => `${firstGridColumnSize}% ${secondGridColumnSize}%`};
  margin: 0 auto;

  > section {
    width: 100%;
  }

  @media all and (max-width: ${({ breakpoint }) => breakpoint ?? layout.sm}) {
    display: block;
  }
`
